import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CpfCnpjPipeModule } from '@toro/common/shared/pipes';
import { BankInfoTextComponent } from './bank-info-text.component';

@NgModule({
    imports: [
        CommonModule,
        CpfCnpjPipeModule,
    ],
    declarations: [
        BankInfoTextComponent,
    ],
    exports: [
        BankInfoTextComponent
    ]
})
export class BankInfoTextModule {}
